import React from 'react';
import { motion } from 'framer-motion';
import { Shield, User, Heart } from 'lucide-react';
const pillars = [{
  num: '01',
  title: 'El Desarme Emocional',
  icon: Shield,
  desc: 'Validar la emoción del otro sin necesariamente aceptar su conclusión. Esto elimina el muro defensivo al instante y cambia la dinámica de confrontación.',
  badge: 'Reduce hostilidad en 65%'
}, {
  num: '02',
  title: 'El Reencuadre de Identidad',
  icon: User,
  desc: "Has pasado de ser 'amante' a ser 'logística'. Recupera tus propios intereses. No hay nada más atractivo que alguien que se hace cargo de su propio bienestar.",
  badge: null
}, {
  num: '03',
  title: 'El Santuario de Calma',
  icon: Heart,
  desc: "Basado en la 'Ley de la No-Resistencia'. Deja de ser la fuente de presión y conviértete en un refugio. Deja de pedir amor para empezar a proyectar valor.",
  badge: null
}];
export function Pillars() {
  return <section className="py-24 px-6" data-id="element-110">
      <div className="max-w-6xl mx-auto" data-id="element-111">
        <div className="text-center mb-16" data-id="element-112">
          <h2 className="text-4xl md:text-5xl mb-4" data-id="element-113">
            Los Pilares de la Re-Conexión
          </h2>
          <p className="text-lg text-charcoal-light max-w-2xl mx-auto" data-id="element-114">
            El matrimonio no se salva convenciendo con lógica, se salva
            cambiando la polaridad emocional.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-115">
          {pillars.map((pillar, index) => <motion.div key={pillar.num} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-gold/10 hover:border-gold/30 transition-colors relative group" data-id="element-116">
              <div className="text-gold/20 font-serif text-6xl absolute top-6 right-6 font-bold group-hover:text-gold/30 transition-colors" data-id="element-117">
                {pillar.num}
              </div>

              <div className="w-12 h-12 bg-navy/5 rounded-full flex items-center justify-center mb-8" data-id="element-118">
                <pillar.icon className="w-6 h-6 text-navy" strokeWidth={1.5} data-id="element-119" />
              </div>

              <h3 className="text-2xl mb-4 pr-12" data-id="element-120">{pillar.title}</h3>
              <p className="text-charcoal-light leading-relaxed mb-6" data-id="element-121">
                {pillar.desc}
              </p>

              {pillar.badge && <div className="inline-flex items-center gap-2 bg-gold/10 text-navy text-xs font-medium px-3 py-1.5 rounded-full" data-id="element-122">
                  <span className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-123"></span>
                  {pillar.badge}
                </div>}
            </motion.div>)}
        </div>
      </div>
    </section>;
}